
export default class Search {
    static init() {
		const searchForms = document.querySelectorAll('[data-search-form]');
		searchForms.forEach(form => new Search(form) );
    }

	constructor(form) {

        this.models = window.models;
        this.searchForm = form;

        this.searchInput =  this.searchForm.querySelector('[data-search-input]');


        this.currentFocus;

        this.searchInput.addEventListener('input', (e) => {

            let list;
            let matchingEl;
            let i;
            let value = e.target.value;

            this.closeAllLists();

            if (!value) {
                return;
            }

            this.currentFocus = -1;

            // create a div with a list of items
            list = document.createElement('div');
            list.setAttribute('id', 'autocomplete-list');
            list.setAttribute('class', 'autocomplete-items');

            // foreach model
            this.models.forEach((model,i) => {

                if (model.name.substr(0, value.length).toUpperCase() == value.toUpperCase()) {
                    this.searchInput.parentNode.appendChild(list);

                    this.searchInput.classList.add('is-active');
                    // a DIV element for each matching element
                    matchingEl = document.createElement('a');
                    matchingEl.href = model.url;
                    matchingEl.innerHTML = `<strong>${model.name.substr(0, value.length)}</strong>`;
                    matchingEl.innerHTML += `<span>${model.name.substr(value.length)} </span>`;

                    matchingEl.addEventListener('click', (e) => {
                        this.searchInput.value = e.currentTarget.innerText;
                        this.closeAllLists();
                        this.searchForm.submit();
                    });

                    list.appendChild(matchingEl);
                }
            });
        });

        this.searchInput.addEventListener('keydown', (e) => {
            let item = document.getElementById('autocomplete-list');

            if (item) {
                item = item.getElementsByTagName('a');
            }

            if (e.keyCode == 40) { //down
                this.currentFocus++;
                this.addActive(item);

            } else if (e.keyCode == 38) { //up
                this.currentFocus--;
                this.addActive(item);

            } else if (e.keyCode == 13) { //activate

                if (this.currentFocus > -1) {
                    if (item) {
                        item[this.currentFocus].click();
                    }
                }
            }
        });

        document.addEventListener('click', (e) => {
            this.closeAllLists(e.target);
        });
	}

    addActive(item) {
        if (!item) {
            return;
        }

        this.removeActive(item);

        if (this.currentFocus >= item.length) {
            this.currentFocus = 0;
        }
        if (this.currentFocus < 0) {
            this.currentFocus = (item.length - 1);
        }

        item[this.currentFocus].classList.add('autocomplete-active');
    }

    removeActive(item) {
        Array.from(item).forEach(element => {
            element.classList.remove('autocomplete-active');
        });
    }

    closeAllLists(elm) {
        const items = document.getElementsByClassName('autocomplete-items');

        this.searchInput.classList.remove('is-active');

        Array.from(items).forEach(item => {
            item.classList.remove('autocomplete-active');

            if (elm != item && elm != this.searchInput) {
                item.parentNode.removeChild(item);
            }
        });
    }
}